"use client";

import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";

export function MobileProfileAction({ agencyName, agencyUrl }: { agencyName: string; agencyUrl: string }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const contactCard = document.querySelector("[data-profile-contact]");
    if (!contactCard) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), { rootMargin: "-66px 0px 0px" });
    observer.observe(contactCard);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;
  return <div className="profile-mobile-action"><a href={agencyUrl} target="_blank" rel="noreferrer">Visit {agencyName} website <ArrowUpRight size={16}/></a></div>;
}
